module.exports = __webpack_public_path__ + "static/media/staticmedia.3545b0ef.svg";